import { tv } from 'tailwind-variants';

export const container = tv({
  base: 'flex line-[21.79px] max-w-full xs:break-all md:break-normal',
  variants: {
    type: {
      essay:
        'flex-col items-center gap-[10px] [&>p__strong]:text-mono-900 [&>p__strong]:uppercase [&>p__strong]:mb-8 [&__img]:m-auto ',
      theme: 'gap-[10px] [&>p__strong]:text-mono-900 [&>p__strong]:uppercase',
      theme_essay: 'flex flex-col gap-[10px] [&>p__strong]:text-mono-900 [&>p__strong]:uppercase',
      courseProgram: 'block [&>p__strong]:text-mono-900 !break-normal !hyphens-auto',
      contentCard:
        'transition ease-in-out delay-100 group-hover:text-white [&]:line-clamp-2 [&]:md:line-clamp-3 pr-8',
      textContent: 'block [&>p__a]:underline [&>p__a]:text-primary-500',
      line_clamped: '[&>p]:line-clamp-4 [&]:line-clamp-4',
      essayPaper: 'flex flex-col',
    },
    align: {
      center: 'text-center',
      left: 'text-left',
      right: 'text-right',
    },
    font: {
      noto: 'font-notoSans',
    },
    color: {
      black: 'text-mono-900',
    },
  },
});
